import useSessionStorageState from 'use-session-storage-state';

export const useJustAddedPaymentMethod = () =>
    useSessionStorageState<boolean | undefined>('justAddedPaymentMethod');
